import { render } from "./equalizer.svg?vue&type=template&id=36090914"
const script = {}
script.render = render

export default script